module.exports = __webpack_public_path__ + "img/4.2a9f5edb.png";